// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"958d0c91","432":"958d0c91","480":"20eecd43","697":"f253791f","768":"958d0c91","825":"20eecd43"}[chunkId] + ".chunk.css";
};